import HeroSlider from "@/components/HeroSlider";
import ProductCarousel from "@/components/ProductCarousel";
import ShopByCategory from "@/components/ShopByCategory";
import ComboCarousel from "@/components/ComboCarousel";
import EditorialCards from "@/components/EditorialCards";
import CollectionsGrid from "@/components/CollectionsGrid";
import InstagramStrip from "@/components/InstagramStrip";
import Seo from "@/components/Seo";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="Reserve 30 Parfums — Luxury Fragrances | Crafted To Leave A Mark"
        description="Luxury fragrances crafted to leave a lasting impression. Parfum-strength concentration, matured 8–10 weeks. 50ml Parfum ₹1,990 · 10ml Roll-On ₹499."
      />
      <HeroSlider />
      <ProductCarousel />
      <ShopByCategory />
      <ComboCarousel />
      <EditorialCards />
      <CollectionsGrid />
      <InstagramStrip />
    </main>
  );
}
